import React from "react";
import { motion } from "framer-motion";

function Follow() {
  const images = [
    "/assets/website-images/insta_1.png",
    "/assets/website-images/insta_2.png",
    "/assets/website-images/insta_3.png",
    "/assets/website-images/insta_4.png",
    "/assets/website-images/insta_5.png",
  ];

  return (
    <section className="follow-con position-relative">
      <div className="container">
        <div className="row">
          <div className="col-12 position-relative">

            {/* TITLE */}
            <motion.div
              className="follow_content text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <h2>
                Follow US on <span>InStagram</span>
              </h2>
              <p>
                Join our Instagram community for updates, special deals, and more!
              </p>
            </motion.div>

            {/* IMAGES */}
            <ul className="follow-slider list-unstyled mb-0">

              {images.map((img, index) => (
                <li key={index} className="m-2 position-relative">
                  <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">

                    <figure className="image mb-0">
                      <img src={img} alt="follow" className="img-fluid" />
                    </figure>

                    <div className="icon">
                      <i className="fa-brands fa-instagram"></i>
                    </div>

                  </a>
                </li>
              ))}

            </ul>

            {/* BACKGROUND CIRCLES */}
            <div className="circle1"></div>
            <div className="circle2"></div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Follow;